import React, { useContext } from 'react';
import { useLocalizedStrings } from '../../../Localization';
import { PublicConfigurationContext } from '../../../Context';
import { ContactCard } from '@aidkitorg/component-library';

export const ProgramContacts = () => {
  const L = useLocalizedStrings()
  const publicConfig = useContext(PublicConfigurationContext)

  const programContacts = publicConfig.programContacts

  if (!programContacts || programContacts.length == 0) {
    return <></>
  }

  const contactCards = programContacts.map((contact, idx) => (
    <ContactCard
      key={idx}
      name={contact.name}
      title={contact.title}
      icon="EnvelopeIcon"
      onIconClick={() => window.location.href = "mailto:"+contact.email}
    />
  ))

  return (
    <>
      <hr />
      <div>
        <div className="font-semibold">{L.admin_panel.program_home.quick_actions.program_contacts}</div>
        <div className="flex flex-col gap-y-4 pt-3">
          {contactCards}
        </div>
      </div>
    </>
  )
}